export const componentName = 'B2bAddBox';
